<script lang="ts">
    import { _ } from "svelte-i18n"
    import OpenGraph from "./OpenGraph.svelte"
    import SchemaOrg from "./SchemaORG.svelte"
    import { location } from "../../store"

    interface SEOProps {
        createdAt?: Date | null
        updatedAt?: Date | null
        keywords?: string
        imageUrl?: string

        metaDescription?: string
        title?: string
        noIndex?: boolean
        active?: boolean
    }

    let {
        createdAt = null,
        updatedAt = null,
        keywords = "",
        metaDescription = "",
        title = "",
        noIndex = false,
        active = true,
        imageUrl,
    }: SEOProps = $props()

    const pageTitle: string = title ? `${title} - ${$_("general.companyName")} ` : `${$_("general.companyName")}`

    keywords += ""

    const openGraphProps = {
        datePublished: createdAt,
        lastUpdated: updatedAt,
        metaDescription,
        pageTitle,
        imageUrl,
    }
    const schemaOrgProps = {
        createdAt,
        updatedAt,
        description: metaDescription,
        title: pageTitle,
    }

    // Produktions-Domain für hreflang/canonical (immer mit www)
    const productionBase = "https://www.familienunternehmen-politik.de"

    // Sprache aus dem Pfad ableiten (zuverlässig im SSR, da $lang dort immer "de" ist)
    const currentLang = ($location.path || "/").startsWith("/en") ? "en" : "de"

    // Slug ohne Sprachpräfix
    const slug = ($location.path || "/").replace(/^\/(de|en)(?=\/|$)/, "") || "/"

    // Sprachversions-URLs
    const deUrl = productionBase + "/de" + (slug === "/" ? "" : slug)
    const enUrl = productionBase + "/en" + (slug === "/" ? "" : slug)

    // Canonical immer auf die aktuelle Sprachversion
    const canonicalUrl = currentLang === "en" ? enUrl : deUrl
</script>

<svelte:head>
    <title>{pageTitle}</title>
    <meta name="description" content={metaDescription} />
    <meta name="keywords" content={keywords} />
    <meta property="og:site_name" content={$_("general.companyName")} />
    {#if noIndex || active === false}
        <meta name="robots" content="noindex, nofollow" />
    {:else}
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
    {/if}
    <link rel="alternate" hreflang="de" href={deUrl} />
    <link rel="alternate" hreflang="en" href={enUrl} />
    <link rel="alternate" hreflang="x-default" href={deUrl} />
    <link rel="canonical" href={canonicalUrl} />
</svelte:head>

<OpenGraph {...openGraphProps} />

<SchemaOrg {...schemaOrgProps} />
